module.exports = __webpack_public_path__ + "static/media/circle-status-to-confirm.e76be6c5.svg";